import { FC } from 'react';
import { Placeholder } from 'rsuite';
import {
	Breadcrumbs,
	HomeIcon, ToggleButton, useUrlParams,
} from '@aleph/shared-components';
import { useBreadcrumbs } from 'wb-spotify/app/routes/superGrid/tool/hooks/useBreadcrumbs';
import { SpotifyLevel, SpotifyLevelId } from 'wb-spotify/app/routes/superGrid/utils';
import { useNavigate, useParams } from 'react-router-dom';

const SpotifyBreadcrumbs: FC = () => {
	const navigate = useNavigate();
	const { params, setUrlParams } = useUrlParams({ navigate, useParams });
	const { breadcrumbs, hasMultiple, loading } = useBreadcrumbs({ params });

	const goHome = () => {
		setUrlParams({
			...params,
			level:   SpotifyLevel.AD_ACCOUNT,
			filters: {},
		});
	};

	const goToBreadcrumb = (level: SpotifyLevel, id?: string | null) => () => {
		let newLevel = SpotifyLevel.CAMPAIGN;

		switch (level) {
			case SpotifyLevel.AD_ACCOUNT:
				newLevel = SpotifyLevel.CAMPAIGN;

				break;
			case SpotifyLevel.CAMPAIGN:
				newLevel = SpotifyLevel.GROUP;

				break;
			case SpotifyLevel.GROUP:
				newLevel = SpotifyLevel.AD;

				break;
		}

		setUrlParams({
			...params,
			level:   newLevel,
			filters: {
				[SpotifyLevelId[level]]: [{ value: [id] }],
			},
		});
	};

	return (
		<div className="flex items-center gap-[8px] min-w-0">
			<ToggleButton
				data-testid="go-home-button"
				onClick={goHome}
				leadingIcon={<HomeIcon />}
				className="h-[40px] w-[40px] flex items-center justify-center p-0"
			/>

			{hasMultiple && <div>Multiple Campaigns</div>}

			{
				loading
				&& <Placeholder.Graph
					active
					className="!h-[24px] !w-[200px]"
				/>
			}

			{!hasMultiple && <Breadcrumbs
				breadcrumbs={breadcrumbs}
				goToBreadcrumb={goToBreadcrumb}
			/>}
		</div>
	);
};

export default SpotifyBreadcrumbs;
